import React from 'react';
import LinearProgress, { LinearProgressProps } from '@material-ui/core/LinearProgress';
import { palettes, SmallBody } from '@indigo-ag/component-module';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';

import { createStylesHook } from 'shared/hooks/createStylesHook';

const useStyles = createStylesHook({
  barColorPrimary: {
    backgroundColor: palettes.coastal.accent.green
  }
});

export const ProgressBar = (props: LinearProgressProps & { value: number }): JSX.Element => {
  /**
   * Styles
   */
  const classes = useStyles();

  return (
    <div>
      {props.value && props.value < 100 ? (
        <SmallBody align="right" color="textSecondary">{`${Math.round(props.value)}%`}</SmallBody>
      ) : (
        <div style={{ textAlign: 'right', marginBottom: 4 }}>
          <FontAwesomeIcon size="lg" icon={faCheckCircle} style={{ color: palettes.coastal.accent.green }} />
        </div>
      )}
      <div style={{ width: '100%', marginRight: 5 }}>
        {props.value && props.value === 100 ? (
          <LinearProgress classes={{ barColorPrimary: classes.barColorPrimary }} variant="determinate" {...props} />
        ) : (
          <LinearProgress variant="determinate" {...props} />
        )}
      </div>
    </div>
  );
};
